"use strict";

export class FilterManager {

	$ = document.querySelector.bind(document);
	rendered = false;

	constructor(data, opts) {
		
		console.log("Constructing FilterManager", arguments);

		if (typeof data == 'string') {
			fetch(data)
				.then((response) => {
				    return response.json();
				}).then((json) => {
					this.setData(json);
				}).catch((ex) => {
    				console.log('filter-manager: parsing failed', ex);
				});
		} else {
			this.setData(data);
		}
		this.name = opts.name;
		this.form = (typeof opts.form == 'string') ? document.querySelector(opts.form) : opts.form;
		this.preprocessData = opts.preprocessData;
		this.internalstate={};
		this.filters = [];
		this.filtermap = {};
		this.fnLog = opts.fnLog;
		this.logtimer = null;
		this.fnSort = opts.sort;
		this.fnPostFilter = opts.fnPostFilter;
		this.rendered = false;
		this.msglevel = opts.msglevel || 0;

		if (this.form) {
			var self = this;
			this.form.addEventListener('change', this.handleFormChange.bind(this));
					
			this.form.addEventListener('submit', function(e) {
				e.preventDefault();
			});
		}
		return this;
	};

	
	checkStatus(response) {
		if (response.status >= 200 && response.status < 300) {
			return response;
		} else {
			error = new Error(response.statusText);
			error.response = response;
			throw error;
		}
	  }

	getFilterBadgeData() {

		let fm = this;

		/*
		 * Build an array in the format:
		 *
		 *    [{name: <filtername>, value: <filtervalue>}, ...]
		 */
		let filtervalues = [];

		// fm.filters.forEach((filter) => {
		// 	console.log("getFilterBadgeData", filter);
		// 	filter.getValues().forEach((value) => {
		// 		console.log(filter, filter.getValues(), value);
		// 		if (value !== undefined) {
		// 			filtervalues.push({name: filter.name, value: value});
		// 		}
		// 	});
		// });

		console.log("Badges", filtervalues);
		return filtervalues;

	};
	
	render() {

		var fm = this, filtereddata = this.rawdata, restoredstate;
		(this.msglevel > 6) && console.log('FilterManager.render', fm);
		
		this.rendered = true;
		
		if (!filtereddata) {
			return;
		}

		// console.log(fm.elBadges);
		if (this.elBadges) {
			let html = this.fnFormatBadges(this.getFilterBadgeData());
			this.elBadges.innerHTML = html;
		}
		

		// Call each filter
        fm.filters.forEach(function(filter) {
			if (filter.fnFilter) {
            	filtereddata = filter.fnFilter.call(filter, fm.getFormValues(filter.name), filtereddata); // Only select, will have issues
			} else if (filter.getFormValues) {
				filtereddata = filter.fnFilterOnly(filter.getFormValues(filter.name), filtereddata);
			} else {
				console.log(`Skipping filter ${filter.name} because it has no filter function`);
			}
        });

		// If there is a post-filter processor defined, call it.
		if (fm.fnPostFilter) {
			fm.fnPostFilter();
		}

		// If a sort function has been supplied, sort the results.
		if (fm.fnSort) {
			filtereddata.sort(fm.fnSort);
		}

        fm.results = filtereddata;

		fm.insertResults(filtereddata);

		fm.logEvent();

	};

	/* Handle any change in any field of the form.
	 *
	 * In addition to being called directly from the change event on the form,
	 * this method is called by text field's keyup handler.
	 * 
	 * Assume that the form values are the source of truth, and change the state
	 * information to match.
	 */
	handleFormChange(evt) {
	
		(this.msglevel > 7) && console.log("handleFormChange", evt, this);
		
		this.formToHistory();
		this.formToState();
		this.render();
	};



	setData(data) {

		(this.msglevel > 6) && console.log("Setting data", data);

		if (this.preprocessData) {
			data = this.preprocessData(data);
		}

		this.rawdata = data;

		// If render has been called, it was probably before an async load of data completed.
		// Re-render so the data is used.
		if (this.rendered) {
			this.render();
		}

		return this;
	};

	setFilterBadges(opts) {

		this.elBadges = typeof opts.element == 'string' ? document.querySelector(opts.element) : opts.element;
		this.fnFormatBadges = opts.fnFormatBadges;

		console.log("setFilterBadges", this.elBadges, this.fnFormatBadges);
		return this;
	};

	setOutput(opts) {

		this.outputselector = opts.selector;
		this.fnFormat = opts.fnFormat;
		this.outputpostprocess = opts.postprocess;

		return this;
	};
	
	/*
	 * State management functions.
	 */	


	/* 
	 * Set the state kept in the FilterManager instance.
	 */
	setState(name, value) {

		var fm = this;
		
		console.log("state", arguments);

		/*
		 * If called with a falsy value, ignore it.
		 */
		if (!name) {
			return;
		}

		/* If called with one argument, the argument is an object of key/value pairs. */
		if (arguments.length == 1) {
			Object.keys(name).forEach(function(k) {
				fm.setState(k, name[k]);
			});
		} else {
			/* If called with two arguments, the first is a keyword value and the second is the value. */
			if (!Array.isArray(value)) {
				value = [value];
			}
			fm.internalstate[name] = value;
		}

	};


	formToState() {

		var fm = this, filtereddata = this.rawdata, restoredstate;

		// Call each filter
        fm.filters.forEach(function(filter) {
			if (filter.getFormValues) {
				fm.setState(filter.name, filter.getFormValues());
			}
        });

	};


	loadState(state) {
		this.setState(state);
		this.UrlToState();	
		this.stateToForm();	
	};

	UrlToState() {

		let fm = this;
		let restoredstate;

		restoredstate = this.parseRequest();
		console.log("UrlToState", restoredstate);

		for (let name in restoredstate) {
			if (restoredstate.hasOwnProperty(name)) {
				let values = restoredstate[name];
				if (values) {
					fm.setState(name, values.split(/;/));
				}
			}
		}

	};


	formToHistory() {

		var fm = this, baseurl, params, queryparms;
		
		baseurl = document.location.protocol + '//' + document.location.host + document.location.pathname;
		params = [];
		
		// Call each filter
        fm.filters.forEach((filter) => {
			if (filter.getFormValues) {
				let values = filter.getFormValues();

				if (values.length) {
					values = values.map((v) => {
						v = v.replace(/;/g, '%2f');
						v = v.replace(/ /g, '%20');
						return v;
					});
					params.push(`${filter.name}=${values.join(';')}`);
				}
			}
        });

		queryparms = "";
        if (params.length) {
            queryparms = '?' + params.join('&');
        }
        window.history.replaceState(null, queryparms, baseurl+queryparms);
	};

	
	
	stateToForm() {

		var fm = this;

		fm.filters.forEach(function(filter) {
			if (fm.internalstate[filter.name] != undefined) {
				filter.setFormValues(fm.internalstate[filter.name]);
			}
		});
	};
	
	
// 	/*
// 	 * State management functions.
// 	 */	
// 	UrlToForm() {

// 		let fm = this;
// 		let restoredstate;

// 		restoredstate = this.parseRequest();
// 		console.log("history to form", restoredstate);

// 		fm.filters.forEach((filter) => {

// 			let qp = filter.name;
// 			let values = restoredstate[qp];
// 			if (values && values.length) {
// 				values = values.split(/;/);
// 			} else {
// 				values = [];
// 			}

// 			filter.setFormValues(values);

// // 			if (fm.internalstate[filter.name] != undefined) {
// // // 				filter.el.value = fm.internalstate[filter.name];
// // 			}
// 		});
// 	};

		
		
	
	// formToState() {

	// 	var fm = this, filtereddata = this.rawdata, restoredstate;

	// 	// Call each filter
    //     fm.filters.forEach(function(filter) {
	// 		if (filter.getValues) {
	// 			fm.state(filter.name, filter.getValues());
	// 		}
    //     });

	// };

	

	// stateToHistory() {

	// 	var fm = this, baseurl, params, queryparms;

	// 	// Update the session history
    //     baseurl = document.location.protocol + '//' + document.location.host + document.location.pathname;
    //     params = [];
	// 	Object.keys(fm.internalstate).forEach(function(n) {
	// 		if (fm.internalstate[n] !== "") {
	// 		   params.push(n+"="+fm.internalstate[n])
	// 	    }
	// 	});
	// 	queryparms = "";
    //     if (params.length) {
    //         queryparms = '?' + params.join('&');
    //     }
    //     window.history.replaceState(fm.internalstate, queryparms, baseurl+queryparms);
	// };



	// handleChange(e) {

	//     var target, name, query, queryparm, baseurl,
	//         filter = this, manager = filter.manager;

	//     console.log("change", e);

    //     /*
    //      * Find the new value of the input field.
    //      */
    //     target = e.target;
    //     query = target.value;
	// 	name = filter.name;

	// 	manager.state.call(manager, name, query);
	// 	manager.updateHistory.call(manager);
	// 	manager.manager.render();
	// };



	/*
	 * Add a Filter instance to the FilterManager.
	 */
	addFilter(filter) {

		/* Add to the filters array... */
		this.filters.push(filter);
		
		// this.filtermap[filter.name] = filter;

		/* Link from each Filter instance back to the owning FilterManager. */
		filter.manager = this;

		// Start with an explict undefined as the state
		this.setState(filter.name, undefined);

	};

	logEvent() {
		var fm = this;

		if (fm.logtimer) {
			clearTimeout(fm.logtimer);
		}

		if (fm.fnLog) {
			fm.logtimer = setTimeout(function() {fm.fnLog();}, 2000);
		}
	};


	insertResults() {
		(this.msglevel>2) && console.log("Outputting", this.results);

		var html = this.fnFormat.call(this, this.results);

		document.querySelector(this.outputselector).innerHTML = html;
		if (this.outputpostprocess) {
			this.outputpostprocess(this.outputselector);
		}
	};


	parseRequest(s) {
		/* Replacement for an old KSJS routine that didn't handle UTF-8 encoded characters in the query parameters. */


		/*
		* parseRequest -- parse the parameters specified in the URL into a "request" object
		*
		* This function returns an object that has a property for each parameter
		* in the URL.  The value of the property is the value as specified in the
		* URL.  For example, with the URL "whatever.html?dog=Max&cat=Saturn",
		* the object returned would have two properties:
		*
		*    request.dog = "Max" and request.cat="Saturn".
		*
		* The returned object is typically named "request", and is modelled after the
		* Server-Side JavaScript "request" object.
		*
		* Note: No facility is available to handle parameters that are specified
		* multiple times.  The last value specified on the URL is the one returned.
		*/
		var request = {};
		var a, i, v;

		// If the caller didn't specify a string, use the page's URL.
		if (!s) {
			s = window.location.search;
		}

		// Strip the leading question mark, if any
		if (s.substr(0,1) == '?') {
			s = s.substr(1);
		}

		// Split the query/search string into "name=value" strings.
		a = s.split(/&/);

		// For each string, split into the name and value, and assign to
		// the request object.
		for (i = 0; i < a.length; i++) {
			v = a[i].match(/^([^=]*)=(.*)$/);
			if (v) {
		v[1] = v[1].replace( /\+/g, " " );      // change '+' into ' '
		v[2] = v[2].replace( /\+/g, " " );      // change '+' into ' '
				request[decodeURIComponent(v[1])] = decodeURIComponent(v[2]);
			}
		}

		return request;

	};

}
